import React, { useEffect, useRef } from 'react';
import { defineCustomElements } from '@om-design-system/web-components/loader';

const OmCircularProgress = React.forwardRef(({
  value = 0,
  max = 1,
  indeterminate = false,
  size = 'small',
  className,
  style,
  ...props
}, ref) => {
  const elementRef = useRef(null);

  useEffect(() => {
    defineCustomElements();
  }, []);

  return (
    <omk-circular-progress
      ref={(el) => {
        elementRef.current = el;
        if (ref) {
          if (typeof ref === 'function') {
            ref(el);
          } else {
            ref.current = el;
          }
        }
      }}
      value={value}
      max={max}
      indeterminate={indeterminate}
      size={size}
      className={className}
      style={style}
      {...props}
    />
  );
});

OmCircularProgress.displayName = 'OmCircularProgress';

export default OmCircularProgress;
